import { render, staticRenderFns } from "./select-head.vue?vue&type=template&id=727ad483"
import script from "./select-head.vue?vue&type=script&lang=js"
export * from "./select-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports